// Module
var code = `<div class="row">
    <table class="table">
        <tr>
            <td>#</td>
            <td>Date</td>
            <td>Country</td>
            <td>Time</td>
            <td>ID</td>
            <td>Player ID</td>
            <td>Total: {{ total | number:2 }}</td>
            <td>Product key</td>
        </tr>
        <tr ng-repeat="p in data">
            <td>{{\$index + 1}}</td>
            <td>{{p.date}}</td>
            <td>{{p.country}}</td>
            <td>{{p.datetime}}</td>
            <td>{{p.uuid}}</td>
            <td>{{p.player_id}}</td>
            <td>{{p.price | number:2 }}</td>
            <td>{{p.product_key}}</td>
        </tr>
    </table>
</div>
`;
// Exports
module.exports = code;